// THIS FILE IS AUTO-GENERATED BY vite-plugin-api-constructor.
// DO NOT EDIT MANUALLY.

import type { z } from "zod";
import * as R0 from "@/api/users/info";
import * as R1 from "@/api/tracks/index";
import * as R2 from "@/api/courses/index";
import * as R3 from "@/api/reviews/index";
import * as R4 from "@/api/lectures/index";
import * as R5 from "@/api/schedules/index";
import * as R6 from "@/api/semesters/index";
import * as R7 from "@/api/timetables/index";
import * as R8 from "@/api/courses/$courseId";
import * as R9 from "@/api/semesters/current";
import * as R10 from "@/api/sync/requests/index";
import * as R11 from "@/api/sync/requests/active";
import * as R12 from "@/api/courses/auto-complete";
import * as R13 from "@/api/planner-courses/index";
import * as R14 from "@/api/users/writable-review";
import * as R15 from "@/api/users/written-reviews";
import * as R16 from "@/api/users/$userId/lectures";
import * as R17 from "@/api/users/$userId/wishlist";
import * as R18 from "@/api/reviews/$reviewId/index";
import * as R19 from "@/api/reviews/$reviewId/liked";
import * as R20 from "@/api/timetables/$timetableId";
import * as R21 from "@/api/timetables/my-timetable";
import * as R22 from "@/api/department-options/index";
import * as R23 from "@/api/users/$userId/reviews/liked";
import * as R24 from "@/api/users/$userId/planners/index";
import * as R25 from "@/api/sync/requests/$requestId/stream";
import * as R26 from "@/api/users/$userId/interested-departments";
import * as R27 from "@/api/users/$userId/planners/$plannerId/index";
import * as R28 from "@/api/users/$userId/planners/$plannerId/reorder";
import * as R29 from "@/api/timetables/$timetableId/custom-blocks/index";
import * as R30 from "@/api/users/$userId/planners/$plannerId/remove-item";
import * as R31 from "@/api/users/$userId/planners/$plannerId/update-item";
import * as R32 from "@/api/users/$userId/planners/$plannerId/add-future-item";
import * as R33 from "@/api/timetables/$timetableId/custom-blocks/$customblockId";
import * as R34 from "@/api/users/$userId/planners/$plannerId/add-arbitrary-item";

export const responseMap = {
  "/users/info": {
    GET: R0.GETResponse,
  },
  "/tracks": {
    GET: R1.GETResponse,
  },
  "/courses": {
    GET: R2.GETResponse,
  },
  "/reviews": {
    GET: R3.GETResponse,
    POST: R3.POSTResponse,
  },
  "/lectures": {
    GET: R4.GETResponse,
  },
  "/schedules": {
    GET: R5.GETResponse,
  },
  "/semesters": {
    GET: R6.GETResponse,
  },
  "/timetables": {
    GET: R7.GETResponse,
    POST: R7.POSTResponse,
    PATCH: R7.PATCHResponse,
    DELETE: R7.DELETEResponse,
  },
  "/courses/:courseId": {
    GET: R8.GETResponse,
  },
  "/semesters/current": {
    GET: R9.GETResponse,
  },
  "/sync/requests": {
    POST: R10.POSTResponse,
  },
  "/sync/requests/active": {
    GET: R11.GETResponse,
  },
  "/courses/auto-complete": {
    GET: R12.GETResponse,
  },
  "/planner-courses": {
    GET: R13.GETResponse,
  },
  "/users/writable-review": {
    GET: R14.GETResponse,
  },
  "/users/written-reviews": {
    GET: R15.GETResponse,
  },
  "/users/:userId/lectures": {
    GET: R16.GETResponse,
  },
  "/users/:userId/wishlist": {
    GET: R17.GETResponse,
    PATCH: R17.PATCHResponse,
  },
  "/reviews/:reviewId": {
    PUT: R18.PUTResponse,
  },
  "/reviews/:reviewId/liked": {
    PATCH: R19.PATCHResponse,
  },
  "/timetables/:timetableId": {
    GET: R20.GETResponse,
    PATCH: R20.PATCHResponse,
  },
  "/timetables/my-timetable": {
    GET: R21.GETResponse,
  },
  "/department-options": {
    GET: R22.GETResponse,
  },
  "/users/:userId/reviews/liked": {
    GET: R23.GETResponse,
  },
  "/users/:userId/planners": {
    GET: R24.GETResponse,
    POST: R24.POSTResponse,
  },
  "/sync/requests/:requestId/stream": {
    GET: R25.GETResponse,
  },
  "/users/:userId/interested-departments": {
    PUT: R26.PUTResponse,
  },
  "/users/:userId/planners/:plannerId": {
    PATCH: R27.PATCHResponse,
    DELETE: R27.DELETEResponse,
  },
  "/users/:userId/planners/:plannerId/reorder": {
    POST: R28.POSTResponse,
  },
  "/timetables/:timetableId/custom-blocks": {
    GET: R29.GETResponse,
    POST: R29.POSTResponse,
  },
  "/users/:userId/planners/:plannerId/remove-item": {
    POST: R30.POSTResponse,
  },
  "/users/:userId/planners/:plannerId/update-item": {
    POST: R31.POSTResponse,
  },
  "/users/:userId/planners/:plannerId/add-future-item": {
    POST: R32.POSTResponse,
  },
  "/timetables/:timetableId/custom-blocks/:customblockId": {
    PATCH: R33.PATCHResponse,
    DELETE: R33.DELETEResponse,
  },
  "/users/:userId/planners/:plannerId/add-arbitrary-item": {
    POST: R34.POSTResponse,
  },
} as const;

export type APIPath = keyof typeof responseMap;
export type ResponseMap = {
  [P in keyof typeof responseMap]: {
    [M in keyof typeof responseMap[P]]: z.infer<(typeof responseMap)[P][M]>;
  }
};

export type ResponseOf<P extends APIPath, M extends keyof ResponseMap[P]> = ResponseMap[P][M];
